import { usePlanSetHeaderSectionQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  displayName: string;
}

export function useQuery(id: string) {
  const tuple = usePlanSetHeaderSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.planSet?.id ?? '',
        displayName: tuple.data?.planSet?.displayName ?? 'Plan Set Detail'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
